module.exports = ".list-divider {\n  padding-bottom: 15px; }\n\n.header {\n  margin-bottom: 10px; }\n\n.mat-select,\n.mat-input-container {\n  width: 400px; }\n\n.loading-indicator {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\nmat-form-field {\n  margin-right: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/submission/components/add-submitting-entity-dialog.component.scss
// module id = ./src/app/submission/components/add-submitting-entity-dialog.component.scss
// module chunks = main